import React from 'react'
import * as R from 'remeda'

import { type RoleName } from '~/gql/graphql'
import { useCommonQuery } from '~/hooks/useCommonQuery'
import { useIsCoreMember } from '~/hooks/useIsCoreMember'
import { exists } from '~/utils'

// AI機能のオンオフを変更できるのは M-Force / M-Force管理者（＋コアメンバー）のみ。
// ユーザー管理者（USER_MANAGER 系）は閲覧のみで変更不可。
const editableRoleNames: RoleName[] = ['MFORCE', 'MFORCE_WITH_SETTING']

export const useCanEditAiSettings = (brandAccountId: string) => {
  const { data } = useCommonQuery()
  const isCoreMember = useIsCoreMember()

  return React.useMemo(() => {
    if (isCoreMember) {
      return true
    }

    const roleName = data?.brandAccountRoles?.find(
      (role) => role.brandAccount.id === brandAccountId,
    )?.role?.name

    return exists(roleName) && R.isIncludedIn(roleName, editableRoleNames)
  }, [brandAccountId, data?.brandAccountRoles, isCoreMember])
}
